import { connect } from 'react-redux';
import { selectProduct } from 'Favourites/store/reducers/data/products';

import {
    selectLists,
    selectSelectedListId,
} from 'store/reducers/data/shoppingList';

import { moveProduct } from 'Favourites/store/actions';
import { LIST_TYPE } from 'Favourites/store/constants';

const mapStateToProps = (state, ownProps) => {
    const availableLists = selectLists(state);
    const selectedList = selectSelectedListId(state);
    const articleData = selectProduct(state, ownProps.article);
    const text = ownProps.text;

    return { articleData, availableLists, selectedList, text };
};

const mapDispatchToProps = (dispatch) => {
    return {
        move: (articleData, toList, selectedList, showToastr = false) => {
            dispatch(moveProduct(articleData, toList, selectedList, LIST_TYPE, showToastr));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
